/** Store listings — keep in sync with functions/appLinks.js and public/open.html */
export const IOS_APP_STORE_URL =
  'https://apps.apple.com/us/app/healthy-pet-care-organizer/id6780182589';

export const ANDROID_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.healthypet.app';
